// Material inquiry
import {getQuery, isEmpty, isNotEmpty} from "../../tools/utils";
import API from "../../apis";

let cacheSize = parseInt(localStorage.getItem('pageSize'))
const tableSet = {
    tableSet:{
        row_key:'EPO',
        table_class: 'layout-table',
        height:'',
        dense: true,
        edit: false,
        isFullscreen:false,
        hidePagination: false,
        // selected: [],
        // selection: 'single',
        maxHeight: '',
        separator: 'cell', //表格边框
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 2, page: 1, search: '' },
        data:[],
        columns: [
            // { name: 'FInterID', field: 'FInterID', label: '采购申请单内码', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FBillNo', field: 'FBillNo', label: '采购订单编号', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FPRBILLNO', field: 'FPRBILLNO', label: '采购申请单单号', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'VBELN', field: 'VBELN', label: '施耐德发货单号（80号）', check: true, required: true, style: 'min-width: 140px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FBillNoXS', field: 'FBillNoXS', label: '销售订单编号', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FEntryID', field: 'FEntryID', label: '行号', check: true, required: true, style: 'min-width: 60px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FNumber', field: 'FNumber', label: '物料编码', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'MATNR', field: 'MATNR', label: '订货号', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FModel', field: 'FModel', label: '规格型号', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FQTY', field: 'FQTY', label: '数量', check: true, required: true, style: 'min-width: 80px', align: 'right', sortable: true, format: val => `${val}` },
            { name: 'FDATE', field: 'FDATE', label: '采购申请制单日期', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FPODATE', field: 'FPODATE', label: '采购订单制单日期', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FExplanation', field: 'FExplanation', label: '采购订单备注', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FSupplyName', field: 'FSupplyName', label: '供应商名称', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FClosed', field: 'FClosed', label: '关闭标志', check: true, required: true, style: 'min-width: 100px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FMrpClosed', field: 'FMrpClosed', label: '行业务关闭标志', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FStatus', field: 'FStatus', label: '单据状态', check: true, required: true, style: 'min-width: 100px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FStockQty', field: 'FStockQty', label: '入库数量', check: true, required: true, style: 'min-width: 100px', align: 'right', sortable: true, format: val => `${val}` },
            { name: 'FAuxPriceDiscount', field: 'FAuxPriceDiscount', label: '实际含税单价', check: true, required: true, style: 'min-width: 120px', align: 'right', sortable: true, format: val => `${val}` },
            { name: 'FAllAmount', field: 'FAllAmount', label: '折扣率', check: true, required: true, style: 'min-width: 100px', align: 'right', sortable: true, format: val => `${val}` },
            { name: 'FTaxRate', field: 'FTaxRate', label: '价税合计', check: true, required: true, style: 'min-width: 100px', align: 'right', sortable: true, format: val => `${val}` },
            { name: 'FJQ', field: 'FJQ', label: '交货日期', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
            { name: 'FNote', field: 'FNote', label: '销售订单备注', check: true, required: true, style: 'min-width: 120px', align: 'left', sortable: true, format: val => `${val}` },
        ],
        visibleColumns: [],
        tools: {
            isShow:true,
            active_index: 1,
            buttons: [
            ]
        }
    },
}
const state = ()=>({
    purchaseOrder:Object.assign({},tableSet)
})
const getters = {
    getTable:state => state.purchaseOrder.tableSet,
}
const mutations = {
    ['setResetFun'](state, data) {
        state.purchaseOrder.tableSet.resetFun = data;
    },
    ['clearSelected'](state, data) {
        state.purchaseOrder.tableSet.selected = [];
    },
    ['setList'](state, data) {
        state.purchaseOrder.tableSet.data = data.data.data;
        state.purchaseOrder.tableSet.selected = !isEmpty(data.data.data)  ? [data.data.data[0]] : [];
        state.purchaseOrder.tableSet.pagination.count = data.data.count;
    },
    ['setTableHeight'](state, data){
        let height = data+50
        state.purchaseOrder.tableSet.height = height + 'px';
    },
}
const actions = {
    ['getList']({ state, commit ,dispatch},payload) {
        if (state.purchaseOrder.tableSet.loading == true) return;
        commit('clearList');
        let msg = {
            event: "command",
            data: {
                run: "read_order",  //需要获取的数据方法
                query: payload             //筛选查询条件
            }
        };
        console.log(msg);
        dispatch('channel/socket_send', msg, { root: true })
        state.purchaseOrder.tableSet.loading = true
    },
    ['setList']({ state, commit ,dispatch},payload) {
        state.purchaseOrder.tableSet.loading = false;
        commit('setList',payload.result);
        // if(isNotEmpty(payload?.result?.data?.data)){
        //     dispatch('getSoEntryList');
        // }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
